import { IErmCapabilityApiClientServiceConfig } from './erm-capability-api-client.service-config';
import { ErmApiClientBuilderService } from '../erm-api-client-builder.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { GetAppStreamEnvironmentsResponse } from './responses/GetAppStreamEnvironmentsResponse';
import { GetAppStreamEnvironmentResponse } from './responses/GetAppStreamEnvironmentResponse';
import { GetUserSettingsResponse } from './responses/GetUserSettingsResponse';
import { StartStreamingSessionRequest } from './requests/StartStreamingSessionRequest';
import { StartStreamingSessionResponse } from './responses/StartStreamingSessionResponse';
import { StartEnvironmentScalingResponse } from './responses/StartEnvironmentScalingResponse';
import { PutUserSettingsRequest } from './requests/PutUserSettingsRequest';
import { PutUserSettingsResponse } from './responses/PutUserSettingsResponse';
import { GetScaleAccountProgress } from './responses/GetScaleAccountProgress';

export class ErmCapabilityApiClientService {

  httpClient: HttpClient;

  constructor(config: IErmCapabilityApiClientServiceConfig, httpClientBuilder: ErmApiClientBuilderService) {
    this.httpClient = httpClientBuilder
      .useBaseUrl(config.baseUrl)
      .useLogging(config.enableLogging)
      .useAuthHeader(config.authHeaderResolver)
      .acceptJson()
      .build();
  }

  async getAppStreamEnvironments(): Promise<HttpResponse<GetAppStreamEnvironmentsResponse>> {
    return await this.httpClient.get<GetAppStreamEnvironmentsResponse>('appstream/environments', { observe: 'response' }).toPromise();
  }

  async getAppStreamEnvironment(envId: string): Promise<HttpResponse<GetAppStreamEnvironmentResponse>> {
    return await this.httpClient.get<GetAppStreamEnvironmentResponse>(`appstream/environments/${envId}`, { observe: 'response' }).toPromise();
  }

  async getUserSettings(): Promise<HttpResponse<GetUserSettingsResponse>> {
    return await this.httpClient.get<GetUserSettingsResponse>('settings/user', { observe: 'response' }).toPromise();
  }

  async putUserSettings(request: PutUserSettingsRequest): Promise<HttpResponse<PutUserSettingsResponse>> {
    return await this.httpClient.put('settings/user', request, { observe: 'response' }).toPromise();
  }

  async startAppStreamSession(request: StartStreamingSessionRequest): Promise<HttpResponse<StartStreamingSessionResponse>> {
    return await this.httpClient.post<StartStreamingSessionResponse>('appstream/sessions/start', request, { withCredentials: true, observe: 'response' }).toPromise();
  }

  async startScalingEnvironmentServices(envId: string): Promise<HttpResponse<StartEnvironmentScalingResponse>> {
    return await this.httpClient.post<StartEnvironmentScalingResponse>(`appstream/environments/${envId}/scale-up`, {}, { observe: 'response' }).toPromise();
  }

  async getScalingProgress(executionArn: string): Promise<HttpResponse<GetScaleAccountProgress>> {
    return await this.httpClient.get<GetScaleAccountProgress>(`appstream/scale-progress?executionArn=${executionArn}`, { observe: 'response' }).toPromise();
  }
}
